/* unplugin-vue-components disabled */import "regenerator-runtime/runtime.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapMutations } from 'vuex';
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import Swiper from "vux/src/components/swiper/swiper.vue"; // this line is trasformed by vux-loader
import SwiperItem from "vux/src/components/swiper/swiper-item.vue"; // this line is trasformed by vux-loader
import TpDialog from '@/components/NewVuxComponents/TpDialog';
import { apinoticelist, apiservicerecommendlist, apiservicetypelist, apibannerlist, apisystemsettingByCode, getEnterprises } from '@/api';
import { menuMapping } from '@/constant';
import SmyGrid from '@/components/SmyGrid/SmyGrid';
import SmyGridItem from '@/components/SmyGrid/SmyGridItem';
import Banner from './components/Banner';
import Notice from './components/Notice';
import HomeCard from './components/HomeCard';
export default {
  name: 'Home',
  components: {
    HomeCard: HomeCard,
    Banner: Banner,
    Notice: Notice,
    ViewBox: ViewBox,
    Swiper: Swiper,
    SwiperItem: SwiperItem,
    SmyGrid: SmyGrid,
    SmyGridItem: SmyGridItem,
    TpDialog: TpDialog
  },
  data: function data() {
    return {
      showReturnVisitModal: false,
      codeMap: {},
      menuMapping: menuMapping,
      bannerList: [],
      noticeList: [],
      toDoList: [],
      toDoCountObj: {},
      funNavList: [],
      funNavCount: {},
      // 对象，key为code，value为数量
      hasMounted: false,
      showAnonymousModal: false,
      showEventAnonymousModal: false,
      is_anonymous_eval: 0,
      showExecuteModal: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('globalStore', ['user', 'pageReload'])), {}, {
    // 未登录
    notLogin: function notLogin() {
      return !this.user.id || this.user.id === -1;
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapMutations('globalStore', ['_pageReload'])), {}, {
    init: function init() {
      var _this = this;
      var codes = '40008,40010,40011,40012,40013,40014,90001,90002,90003,90004,90005,90006,90007,90008,90009,90010,90011,90012,90013';
      getEnterprises({
        codes: codes
      }).then(function (res) {
        if (res.success) {
          res.data.forEach(function (v) {
            _this.$set(_this.codeMap, v.code, v.value);
          });
        }
      });
    },
    evaluateCancel: function evaluateCancel() {
      var v = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      if (this.notLogin) {
        this.$router.push({
          name: 'Login'
        });
      }
      if (v === 1) {
        this.showAnonymousModal = false;
      } else if (v === 2) {
        this.showExecuteModal = false;
      } else if (v === 3) {
        this.showEventAnonymousModal = false;
      } else if (v === 4) {
        this.showReturnVisitModal = false;
      }
    },
    funNavClick: function funNavClick(item) {
      this.$router.push({
        name: 'ServiceItem',
        params: {
          id: item.id,
          service_type_id: item.service_type_id
        },
        query: {
          title: item.name
        }
      });
    },
    testBtn: function testBtn() {
      this.$router.push({
        name: 'ServiceMallHome'
      });
    }
  }),
  activated: function activated() {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // banner
              apibannerlist({
                type: 1,
                object_id: ''
              }).then(function (res) {
                if (res.success) _this2.bannerList = res.data;
              });
              // 企业公告
              apinoticelist({
                pageIndex: 0,
                pageSize: 5
              }).then(function (res) {
                if (res.success) _this2.noticeList = res.data;
              });
              // 获取匿名评价权限
              _context.next = 4;
              return apisystemsettingByCode({
                code: 40001
              }).then(function (res) {
                if (res.success) {
                  _this2.is_anonymous_eval = +res.data.value;
                }
              });
            case 4:
              // 工单评价
              if (_this2.user.type === 1 &&
              // 评价工单入口
              _this2.user.evaluateState === 0 &&
              // 评价状态 未评价
              _this2.user.oid // 工单号存在
              ) {
                _this2.showAnonymousModal = true;
              }
              // 事件评价
              if (_this2.user.eventEvaluateState === 0 && _this2.user.eventId) {
                _this2.showEventAnonymousModal = true;
              }
              // 回执单
              if (_this2.user.type === 3 &&
              // 回执工单入口
              !_this2.user.receiptState && _this2.user.oid // 工单号存在
              ) {
                _this2.showExecuteModal = true;
              }
              // 回访单填写
              if (_this2.user.type === 4 &&
              // 回执工单入口
              !_this2.user.returnVisitState && _this2.user.oid // 工单号存在
              ) {
                _this2.showReturnVisitModal = true;
              }
              // 未缓存、已清除缓存 部分
              if (_this2.pageReload.home) {
                // 待办事项
                apiservicerecommendlist().then(function (res) {
                  if (res.success) {
                    _this2.toDoList = res.data;
                  }
                });
                // 功能导航
                apiservicetypelist().then(function (res) {
                  if (res.success) {
                    _this2.funNavList = res.data;
                  }
                });
                _this2._pageReload({
                  home: false
                });
              }
            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  mounted: function mounted() {
    this.hasMounted = true;
  },
  created: function created() {
    this.init();
    // 页面接口重新加载
    this._pageReload({
      home: true
    });
  },
  beforeRouteEnter: function beforeRouteEnter(from, to, next) {
    apibannerlist({
      type: 1,
      object_id: ''
    }).then(function (res) {
      next(function (vm) {
        if (res.success) vm.bannerList = res.data;
      });
    });
  }
};